import React, { ReactNode } from 'react';
import ThreekitSourceContext, {
  apiRoot,
  createSource,
} from './ThreekitSourceContext';
import ThreekitApi from './ThreekitApi';
import axios from 'axios';
import { suspend } from 'suspend-react';
import { fetchOrgFromToken, fetchOrg } from '../queries/users';

interface ThreekitSourceProps {
  token: string;
  env?: string;
  org?: string; // slug or uuid
  _apiRoot?: string; // private api for specifying root without token
  _orgModel?: any; // private api for passing in existing org model
}

type PropsWithChildren<P> = P & { children?: ReactNode };

export default function ThreekitSource(
  props: PropsWithChildren<ThreekitSourceProps>
) {
  const { token } = props;

  if (!token && !props._apiRoot) {
    console.error('token expected');
    return null;
  }
  const source = createSource(token, {
    env: props.env,
    apiRoot: props._apiRoot,
    orgId: props._orgModel?.id,
  });

  const org =
    props._orgModel ?? // internal to the app, since we already have the orgModel, provide it via props
    suspend(async () => {
      const result = props.org
        ? await fetchOrg(source, props.org)
        : await fetchOrgFromToken(source, token);
      // console.log('Org', result);
      return result;
    }, [source.env, token]);

  // instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;

  return (
    <ThreekitSourceContext.Provider value={{ source, org }}>
      <ThreekitApi>{props.children}</ThreekitApi>
    </ThreekitSourceContext.Provider>
  );
}
